// Etiquetas de texto compartidas por las pantallas del supervisor.

const SEVERIDAD_LABEL: Record<string, string> = {
  critical: 'Crítico',
  warning: 'Advertencia',
  info: 'Información',
};

/** Severidad de incidencia en español (el API manda critical/warning/info). */
export function severidadLabel(severidad: string): string {
  return SEVERIDAD_LABEL[severidad] ?? severidad;
}

/**
 * «Líder: Ana Gómez». Si el nombre ya empieza por «Líder» (usuarios genéricos
 * como «Líder Envasado frasco»), se omite el prefijo para no repetirlo.
 */
export function etiquetaLider(nombre: string, apellido: string): string {
  const completo = `${nombre} ${apellido}`.trim();
  return /^l[ií]der\b/i.test(completo) ? completo : `Líder: ${completo}`;
}
